import React from "react";
import { NormalBoldText, NormalText } from "../../../../components/TextParts";
import { Box } from "@mui/system";

export default function PaginationListItem({ head, text }) {
  return (
    <Box sx={{ display: "flex" }}>
      <Box sx={{ width: { xs: "40px", sm: "120px" }, textAlign: "left" }}>
        <NormalBoldText text={head} />
      </Box>
      <Box>
        <NormalText text={text} />
      </Box>
    </Box>
  );
}